<script setup lang="ts">
const { modals, closeModal } = useModalManager();

const handleClose = (modalId: string) => {
  closeModal(modalId);
};
</script>

<template>
  <component
    v-for="modal in modals"
    :key="modal.id"
    :is="modal.component"
    v-bind="modal.props"
    @close="handleClose(modal.id)" />
</template>
